export const API_URL = process.env.REACT_APP_API_ENDPOINT;
export const API_NEW_URL = process.env.REACT_APP_API_CLAIM;

/** Heritage / Health India portal claim track (via API gateway). */
export const PORTAL_DATA_FETCH_APIS = {
  HERITAGE: `${API_URL}/api/v1/heritage/fetch-portal-data`,
  HEALTH_INDIA: `${API_URL}/api/v1/health-india/fetch-portal-data`,
  STAR_HEALTH: `${API_URL}/api/star-health/fetch-portal-data`,
  HERITAGE_STORED: `${API_URL}/api/v1/heritage/stored-portal-data`,
  HEALTH_INDIA_STORED: `${API_URL}/api/v1/health-india/stored-portal-data`,
  STAR_HEALTH_STORED: `${API_URL}/api/star-health/stored-portal-data`,
  FHPL_PREAUTH_DETAILS: `${API_URL}/api/fhpl/preauth/details`,
};
export const API_MICROSERVICE = process.env.REACT_APP_MICROSERVICE_API;
export const API_CGHS = process.env.REACT_APP_CGHS;
export const API_DISCHARGE_ML = process.env.REACT_APP_DISCHARGE_SUMMARY_READER;
export const API_DISCHARGE_ML_GENERATION =
  process.env.REACT_APP_DISCHARGE_SUMMARY_GENERATION;
export const BILL_AUDIT = process.env.REACT_APP_BILL_AUDIT;

export const API_CHATTER = process.env.REACT_APP_CHATTER_API;
export const API_CHATTER_BE = process.env.REACT_APP_CHATTER_BE_API;

export const ROUTES = {
  LOGIN: "/login",
  LANDING: "",
  BILL_AUDIT_AUTH_BRIDGE: "/bill-audit-auth-bridge",
  LANDING_PAGE: "/app",
  DASHBOARD: "/app/dashboard",
  MANAGEMENT_DASHBOARD: "/app/management-dashboard",
  OPERATIONAL_DASHBOARD: "/app/operational-dashboard",
  MAILS: "/app/emails",
  HOSPITAL_MANAGEMENT_DASHBOARD: "/app/hospital-management-dashboard",
  HOSPITAL_OPERATIONAL_DASHBOARD: "/app/hospital-operational-dashboard",
  ASSIGNED_USER_LIST: "/app/assigned-users",

  // Patient related
  PATIENT_LIST: "/app/patient-list",
  PATIENT_DETAILS: "/app/patient-details",
  PATIENT_ADD: "/app/add-case",
  PATIENT_CASE_DETAILS: "/app/patient-case-details",
  ADD_PATIENT: "/app/add-patient",
  ADD_PATIENT_SCHEME: "/app/patientScheme",

  // OHDR related
  APPOINTMENT_LIST: "/app/hd-patient-register",
  OHDR_DETAILS: "/app/ohdr-details",
  OHDR_PATIENT_REGISTRATION: "/app/ohdr-patient-registration",
  HDR_LIST: "/app/hdr-list",
  OTC_LIST: "/app/otc-list",

  // Claims related
  CLAIMS_LIST: "/app/claims-list",
  CLAIM_DETAILS: "/app/claim-details",
  CASE_LIST: "/app/cases-list",
  CASE_DETAILS: "/app/case-details",
  CASE_HISTORY: "/app/patient-case-history",
  LAST_CASE: "/app/patient-last-case",

  // Visit related
  VISIT_HISTORY: "/app/case-visit-history",
  ALL_VISIT: "/app/visit-details",
  LAST_VISIT: "/app/case-last-visit",
  VISIT_DETAILS: "/app/visit",
  BASIC_DETAILS: "/app/basic-Details",
  OPD_BILL_LIST: "/app/opd-bill-list",
  ADD_OPD_BILL: "/app/add-opd-bill",

  // HealthCare related
  ADD_HEALTHCARE: "/app/hospital",
  HEALTHCARE_LIST: "/app/healthCare-list",
  HEALTHCARE_DETAILS: "/app/healthCare-details",

  //Billing
  BILLS_LIST: "/app/billing",
  ADD_NEW_BILL: "/app/add-new-bill",
  PATIENT_BILLING_LIST: "/app/billing-list",
  TPA_BILL_ITEMS_REVIEW: "/app/tpa-bill-items-review",
  GOVT_BILL_ITEMS_REVIEW: "/app/govt-bill-items-review",
  TPA_BILL_AUDIT: "/app/tpa-bill-audit",
  GOVT_BILL_AUDIT: "/app/govt-bill-audit",
  DS_BILL_COMP: "/app/ds-bill-comparison",

  // IPD Billing related
  IPD_BILLING: "/app/ipd-billing",
  ADD_NEW_IPD_BILL: "/app/new-ipd-billing",
  EDIT_IDP_BILL: "/app/edit-ipd-bill",

  // OPD Billing related
  OPD_BILLING: "/app/opd-billing",
  ADD_NEW_OPD_BILL: "/app/new-opd-billing",
  EDIT_OPD_BILL: "/app/edit-opd-bill",

  // ECHS CODE
  ECHS_CODES: "/app/echs-codes",

  // Role Management
  ROLE_MANAGEMENT: "/app/roleManagement",

  //Reports Download
  REPORTS: "/app/reports",

  //Discharge Summary
  DISCHARGE_SUMMARY: "/app/discharge-summary",

  //Document Deficiency
  DOCUMENT_DEFICIENCY: "/app/document-deficiency",

  //Scheme Onboarding
  SCHEME_ONBOARDING: "/app/scheme-onboarding",

  //Email
  EMAIL_LIST: "/app/email-list",

  //Reconciliation
  RECONCILIATION: "/app/reconciliation",
  OP_RECONCILIATION: "/app/op-reconciliation",
  IP_RECONCILIATION: "/app/ip-reconciliation",

  //Portal Details Fetch
  PORTAL_DETAILS_FETCH: "/app/portal-details-fetch",

  //Portal Details Fetch
  PORTAL_DATA_FETCH: "/app/portal-data-fetch",

  //EOD BOD Screen
  EOD_BOD: "/app/eod-bod",

  //Mamagement Alert
  MANAGEMENT_ALERT: "/app/management-alert",
  AGE_STAGE_WISE: "/app/age-stage-wise",

  //Reconciliation File Data
  RECONCILIATION_FILE_DATA: "/app/reconciliation-file-data",

  //Query List
  QUERY_LIST: "/app/query-list",

  NEPHRO_QUERY_LIST: "/app/nephro-query-list",

  //TMS Portal Login
  TMS_PORTAL_LOGIN: "/app/portal-login",
  NHA_PORTAL_LOGIN: "/app/nha-portal-login",
  ALL_PORTAL_LOGIN: "/app/all-portals-login",

  //User Management
  USER_MANAGEMENT: "/app/user-management",

  //Upload File Folder
  DOCUMENTS_UPLOAD: "/app/documents-upload",

  // Credit Register Upload
  CREDIT_REGISTER_UPLOAD: "/app/register-management",
};

export const AUTH_APIS = {
  POST_REGISTRATION_DATA: `${API_URL}/api/v1/auth/register`,
  LOGIN: `${API_URL}/api/v1/auth/authenticate`,
  LOGOUT: `${API_URL}/api/v1/auth/logout`,
  SERVER_TIME: `${API_URL}/api/getTime`,
  VERIFY_OTP: `${API_URL}/api/v1/auth/verify-otp`,

  //Portal Authentication
  PORTAL_AUTH: `${API_URL}/api/portal/hospitalId`,

  //Portal Login APIs
  PORTAL_LOGIN: `${API_URL}/api/login-adapter/portal`,
  PORTAL_LOGOUT: `${API_URL}/api/login-adapter/portal`,
  CHECK_LOGIN_SESSION: `${API_URL}/api/cghs/portal/checkLogin`,
  PORTAL_OTP: `${API_URL}/api/login-adapter/portal`,
  CAPTCHA_PORTAL: `${API_URL}/api/login-adapter/portal`,
  LIVE_SCREEN_PORTAL: `${API_URL}/api/login-adapter/portal`,
};

export const HOSPITAL_APIS = {
  ALL_HOSPITALS: `${API_URL}/api/health_care_management_user/health_cares`,
  GET_HOSPITAL_SCHEMES_API: (hospitalId: number) =>
    `${API_URL}/api/billing/health_cares/${hospitalId}/scheme_codes`,
};

export const RECONCILIATION_APIS = {
  RECONCILIATION: `${API_URL}/api/reconciliation`,
};

export const EODBOD_APIS = {
  EODBOD: `${API_URL}/api/eodBod`,
};

export const DASHBOARD_APIS = {
  OPERATIONAL_DASHBOARD: `${API_URL}/dashboard/operational`,
  OPERATIONAL_DASHBOARD_REFRESH: `${API_URL}/api/cghs/refresh/hospitalId`,
  OP_DASHBOARD_PATIENT_LIST: `${API_URL}/dashboard/operational/countList`,
  DASHBOARD_EXCEL: `${API_URL}/dashboard/operational/exportToExcel`,
  SUBMISSION_SUMMARY: `${API_URL}/dashboard/operational/submission-summary`,
  SETTLEMENT_SUMMARY: `${API_URL}/dashboard/operational/settlement-summary`,
  INTERNAL_QUERY_OPEN_SUMMARY: `${API_URL}/dashboard/operational/internalQueryOpen-summary`,
  PAYER_QUERY_OPEN_SUMMARY: `${API_URL}/dashboard/operational/payerQueryOpen-summary`,
  SUBMISSION_TAT_SUMMARY: `${API_URL}/dashboard/operational/submissionTat-summary`,
  PAYER_QUERY_TAT_SUMMARY: `${API_URL}/dashboard/operational/payerQueryTat-summary`,
  INTERNAL_QUERY_TAT_SUMMARY: `${API_URL}/dashboard/operational/internalQueryTat-summary`,
  INTERNAL_QUERY_OPEN_AGEING_SUMMARY: `${API_URL}/dashboard/operational/internalQueryOpenAgeing-summary`,
  PAYER_QUERY_OPEN_AGEING_SUMMARY: `${API_URL}/dashboard/operational/payerQueryOpenAgeing-summary`,
  SUBMISSION_SUMMARY_DATA: `${API_URL}/dashboard/operational/submission-summary-data`,
  SETTLEMENT_SUMMARY_DATA: `${API_URL}/dashboard/operational/settlement-summary-data`,
  INTERNAL_QUERY_OPEN_SUMMARY_DATA: `${API_URL}/dashboard/operational/internalQueryOpen-summary-data`,
  PAYER_QUERY_OPEN_SUMMARY_DATA: `${API_URL}/dashboard/operational/payerQueryOpen-summary-data`,
  SUBMISSION_TAT_SUMMARY_DATA: `${API_URL}/dashboard/operational/submissionTat-summary-data`,
  PAYER_QUERY_TAT_SUMMARY_DATA: `${API_URL}/dashboard/operational/payerQueryTat-summary-data`,
  INTERNAL_QUERY_TAT_SUMMARY_DATA: `${API_URL}/dashboard/operational/internalQueryTat-summary-data`,
  INTERNAL_QUERY_OPEN_AGEING_SUMMARY_DATA: `${API_URL}/dashboard/operational/internalQueryOpenAgeing-summary-data`,
  PAYER_QUERY_OPEN_AGEING_SUMMARY_DATA: `${API_URL}/dashboard/operational/payerQueryOpenAgeing-summary-data`,
  DASHBOARD_OPERATIONAL_EXPORT_EXCEL: `${API_URL}/dashboard/operational/export-excel`,
};

export const DASHBOARD_CLAIM_APIS = {
  CLAIM_STATUS: `${API_URL}/api/casePreAuth/dashboardListing/portalMetaDataId`,
  DASHBOARD_API: `${API_URL}/api/dashboard/filter`,
  DASHBOARD_API2: `${API_URL}/api/dashboard`,
  HSP_MNG_DASHBOARD_SUMMARY: `${API_URL}/dashboard/management/summary`,
  HSP_MNG_AGE_GROUP: `${API_URL}/dashboard/management/ageGroup`,
  NEW_DASHBOARD_API: `${API_URL}/api/newDashboard`,
  HSP_MNG_REJECTION_DISALLOWANCE: `${API_URL}/dashboard/management/rejection-disallowance-summary`,
  HSP_MANAGEMENT_DASHBOARD: `${API_URL}/dashboard/management`,
  BILL_UPLOAD_RECON: `${API_URL}/dashboard/operational/bill-upload-recon`,
};

export const CHATTER = {
  CHATTER_API: `${API_CHATTER}`,
};

export const REGISTER = {
  REGISTER_API: `${API_URL}/api/registerUploads`
}

export const PATIENT_APIS = {
  ALL_PATIENTS: `${API_URL}/api/patients/search`,
  ALL_PATIENTS_PL: `${API_URL}/api/patients`,
  ALL_PATIENT_LIST: `${API_URL}/api/patient-list/visit-info`,
  TAT_COLOR_CODING: `${API_URL}/api/patient-list/visit-info/tat-color-coding`,
  DOWNLOAD_PATIENTS_PL_EXCEL: `${API_URL}/api/patients/export`,
  DOWNLOAD_PATIENTS_QL_EXCEL: `${API_URL}/api/queryManagement/query/export`,
  PATIENTS_DOC_DEFICIENCY: `${API_URL}/api/patients/search/documentDeficiency`,
  PATIENT_DETAILS: `${API_URL}/api/patients`,
  CREATE_PATIENT: `${API_URL}/api/patients/createPatient`,
  SEARCH_PATIENT: `${API_URL}/api/patients/search/schemeMetaData`,
  PATIENT_SCHEMES: `${API_URL}/api/patient`,
  ADD_PATIENT_CASE: `${API_URL}/api/health_cares`,
  CASE_DETAILS_VISIT_ID: `${API_URL}/api/visit_info`,
  POST_API_TO_GET_PATIENT: `${API_URL}/api/patients/details`,
  GET_PRE_AUTH_QUERY_DATA: `${API_URL}/api/queryManagement/cases`,
  GET_PRE_AUTH_QUERY_DATA_BY_ID: `${API_URL}/api/queryManagement/casePreAuthQueries`,
  REPLY_PAYER_QUERY: `${API_URL}/api/queryManagement/cases`,
  POST_API_FOR_PRE_AUTH_QUERY: `${API_URL}/api/ihxQueriesFrontendTemplate`,
  GET_ENHANCEMENT_DATA: `${API_URL}/api/casesNew`,
  CGHS_GET_ENHANCEMENT_DATA: `${API_URL}/api/cghs/casesNew`,
  CGHS_NEW_GET_ENHANCEMENT_DATA: `${API_URL}/api/cghs_new/casesNew`,
  IHX_SERVICE: `${API_URL}/api/ihx/casesNew`,
  CGHS_NEW_SERVICE: `${API_URL}/api/cghs/casesNew`,
  CGHS_NEW_AB_SERVICE: `${API_URL}/api/cghs_new/casesNew`,
  CGHS_NEW_DIAGNOSIS: `${API_URL}/api/cghs_new/diagnosis`,
  CGHS_NEW_ENHANCEMENT_REASON: `${API_URL}/api/cghs_new/enhancementReason`,
  CGHS_NEW_RESUBMISSION_REASON: `${API_URL}/api/cghs_new/resubmissionReason`,
  POST_CLAIM_CGHS_OP: `${API_URL}/api/casesNew`,
  GET_PORTAL_DATA: `${API_URL}/api/cases`,
  CGHS_SERVICE: `${API_URL}/api/cghs/cases`,
  CGHS_AB_NEW_SERVICE: `${API_URL}/api/cghs_new/cases`,
  HEALTH_INDIA_SERVICE: `${API_URL}/api/v1/health-india`,
  HERITAGE_SERVICE: `${API_URL}/api/v1/heritage`,
  FHPL_SERVICE: `${API_URL}/api/fhpl`,
  STAR_HEALTH_PORTAL_SERVICE: `${API_URL}/api/star-health`,
  GET_REFERRAL_DETAILS: `${API_URL}/api/referral_info/patient`,
  GET_STEPPER_DATA: `${API_URL}/api/visitSchemeStages`,
  GET_PROCEDURE_AMOUNT: `${API_CGHS}/cghs-api/reports/procedureAmount`,
  GET_PROCEDURE_STRATS: `${API_CGHS}/cghs-api/cghs/strats/getStratsDetails`,
  GET_PROCEDURE_AMOUNT_NEW: `${API_CGHS}/cghs-new-api/reports/procedureAmount`,
  GET_PROCEDURE_STRATS_NEW: `${API_CGHS}/cghs-new-api/cghs/strats/getStratsDetails`,
  ENHANCEMENT_PROCEDURE: `${API_URL}/api/portalMetaDataId`,
  SUBMIT_ID: `${API_URL}/api/cases`,
  REGISTER_PORTAL: `${API_URL}/api/portalMetaDataId`,
  REGISTER_PORTAL_CGHS: `${API_URL}/api/cghs/portalMetaDataId`,
  REGISTER_PORTAL_CGHS_NEW: `${API_URL}/api/cghs_new/portalMetaDataId`,
  REGISTER_PORTAL_STARHEALTH: `${API_URL}/api/star-health/portalMetaDataId`,
  FETCH_ENHANCEMENT_PROCEDURE: `${API_URL}/api/casesNew`,
  VALIDATION_PREAUTH: `${API_URL}/api/validation/casesNew`,
  APPROVE_PREAUTH: `${API_URL}/api`,
  ASSIGNED_USER: `${API_URL}/api/assign/self/visitInfo`,
  GET_DIAGNOSIS_DATA: `${API_URL}/api/casePreAuth/portalDiagnosisData`,
  GET_ROOMTYPES_DATA: `${API_URL}/api/ihx/casePreAuth/portalRoomTypesData`,
  GET_PROCEDURE_DATA: `${API_URL}/api/ihx/casePreAuth/portalProcedureData`,
  GET_TREATMENT_DATA: `${API_URL}/api/ihx/casePreAuth/portalTreatmentData`,
  POST_PREAUTH_DATA: `${API_URL}/api/cases`,
  PREAUTH_DATA: `${API_URL}`,
  GET_CHRONIC_ILLNESS: `${API_URL}/api/vidal/casePreAuth/chronicIllness`,
  CGHS_DISCHARGE_TOTAL_BILL_AMOUNT: `${API_URL}/api/cghs/casesNew`,
  CGHS_NEW_DISCHARGE_TOTAL_BILL_AMOUNT: `${API_URL}/api/cghs_new/casesNew`,
  CGHS_NEW_REGISTRATION: `${API_URL}/api/cghs_new/registration`,
  ECHS_REGISTRATION: `${API_URL}/api/echs/registration`,
  CGHS_NEW_BENEFICIARY: `${API_URL}/api/cghs_new/beneficiary`,
  CGHS_NEW_GET_RESUBMISSION_DATA: `${API_URL}/api/cghs_new/casesNew`,
  GET_REFERRAL_DETAIL_BY_ID: `${API_URL}/api/referral_info/casesNew/referralInfo`,
  GET_ALL_VISITS: `${API_URL}/api/visitInfo/visitHistory`,
  CREDIT_NOTE_DATA: `${API_URL}/api/credit_note/visit`,
  VISIT_TYPES: `${API_URL}/api/credit_note/visit-types`,
  CREDIT_NUMBER: `${API_URL}/api/casesNew`,
  ALL_VISIT_TYPES: `${API_URL}/api/visit-types`,
  ALL_VISIT_STAGES: `${API_URL}/api/visit-stages`,
  FILTERED_VISIT_STAGES: `${API_URL}/api/visit-stages/filter`,
  VISIT_SCHEME_STAGE_DOCUMENTS: `${API_URL}/api/visit-scheme-stage-documents/create`,
  ALL_DOCUMENT_TYPES: `${API_URL}/api/documentMaster`,
  ALL_PROCEDURES: `${API_URL}/api/cghs/autoProcedure`,
  ALL_PROCEDURES_NEW: `${API_URL}/api/cghs_new/autoProcedure`,
  ALL_ECHS_PROCEDURES: `${API_URL}/api/casePreAuth/echsPortalProcedureData`,
  DELETE_PROCEDURE: `${API_URL}/api/casePreAuth/portalMetaDataId`,
  CGHS_DELETE_PROCEDURE: `${API_URL}/api/cghs/casePreAuth/portalMetaDataId`,
  CGHS_DELETE_PROCEDURE_NEW: `${API_URL}/api/cghs_new/casePreAuth/portalMetaDataId`,
  ECHS_DELETE_PROCEDURE: `${API_URL}/api/echs/casePreAuth/portalMetaDataId`,
  ECHS_GET_ENHANCEMENT_DATA: `${API_URL}/api/echs/casesNew`,
  ECHS_EXTENSION_OF_STAY: `${API_URL}/api/echs/extension-of-stay`,
 PORTAL_REGISTRATION: `${API_URL}/api/cghs_new`,
  REFERRAL_CHECKLIST: `${API_URL}/api/referral-checklist`,
  UNLISTED_PROCEDURE: `${API_URL}/api/echs/unlisted-procedures`,
  PATIENT_LIST: `${API_URL}/api/patient-list`,
  OTP_VERIFI_CAPF: `${API_URL}/api/cghs_new/capf_new/ip_submission`,

  MAIL_TIMELINE: `${API_URL}/api/patients/mailStatusTimeLine/visitInfoId`,
  ALL_MAILS: `${API_URL}/api/emails/getEmails`,

  ECHS_CLAIM_API: `${API_URL}/api/casePreAuth`,
  ECHS_IMPLANTS: `${API_URL}/echs-api/implant/getImplants`,
  ECHS_ICD_CODES: `${API_URL}/echs-api/icd/getIcdCodes`,
  ECHS_REVIEW_REQUESTS: `${API_URL}/api/echs/review-requests`,
  ECHS_ALERT_REQUESTS: `${API_URL}/api/echs/extension-of-stay/alerts`,
  CGHS_NEW_ALERT_REQUESTS: `${API_URL}/api/cghs_new/caseEnhancement/alerts`,

  UNREAD_NOTIFICATIONS: `${API_CHATTER_BE}/api/notifications/unread-count`,

  TIMELINE: (visit_id: number, case_id: number) =>
    `${API_URL}/api/timeline/case_Id/${case_id}/visit_Info_Id/${visit_id}/timelines`,
  UPDATE_VISIT_STAGE_STATUS: (
    visit_id: number,
    visit_stage_id: number,
    state_id: number
  ) =>
    `${API_URL}/api/visitInfoId/${visit_id}/visit_stages_id/${visit_stage_id}/state_id/${state_id}`,
  VISIT_STAGE_STATUS: (visit_stages_id: number) =>
    `${API_URL}/api/StageStateMapping/${visit_stages_id}/visit_stages_id`,
  UPDATE_PORTAL_STATUS: (visit_id: number, portal_status_scheme: any) =>
    `${API_URL}/api/portalStatus/visitInfo/${visit_id}/portalStatusScheme/${portal_status_scheme}`,
  PORTAL_STATUS_LIST: (scheme_id: number) =>
    `${API_URL}/api/portalStatus/schemeId/${scheme_id}`,
  ALL_COUNT_CARDS: (healthcareId: number) =>
    `${API_URL}/api/patients/search/healthcares/${healthcareId}/liveReport`,
  UPDATE_VISIT_REFERRAL: `${API_URL}/api/patients/patient/referral/visit`,
  ALL_STATE: `${API_URL}/api/states`,
  GET_SHIFT_PATIENT: `${API_URL}/api/case_id`,
  POST_SHIFT_PATIENT: `${API_URL}/api/create`,
  UPDATE_SHIFT_PATIENT: `${API_URL}/api/visit-shift`,
  ECHS_SERVICE: `${API_URL}/api/echs`,
  STARHEALTH_SERVICE: `${API_URL}/api/star-health`,
  STARHEALTH_NEW_SERVICE: `${API_URL}/api/star-health/casePreAuth`,
  STARHEALTH_SPECIALITY: `${API_URL}/api/star-health/casePreAuth/departmentData/portalMetaDataId`,
  GET_QUALIFICATION: `${API_URL}/api/qualification`,
  SAVE_PREAUTH_BY_CASE_ID: `${API_URL}/api/cases`,
  GET_PATIENT: `${API_URL}/api/patients`,
  GET_CASE_BY_ID: `${API_URL}/api/cases`,
  GET_BY_PREAUTH_ID: `${API_URL}/api/casePreAuth`,
  ECHS_DISCHARGE: {
    GET_DISCHARGE: (caseId: number, visitId: number) =>
      `${API_URL}/api/echs/discharge/${caseId}/${visitId}`,
    SUBMIT_DISCHARGE: (caseId: number, visitId: number) =>
      `${API_URL}/api/echs/discharge/submit/${caseId}/${visitId}`,
    SUBMIT_TO_PORTAL: (caseId: number, visitId: number) =>
      `${API_URL}/api/echs/discharge/submit-portal/${caseId}/${visitId}`,
    APPROVE_DISCHARGE: (
      caseId: number,
      visitId: number,
      caseDischargeId: number
    ) =>
      `${API_URL}/api/echs/discharge/approve/${caseId}/${visitId}/${caseDischargeId}`,
  },
};

export const QUERY_APIS = {
  ALL_QUERIES_PL: `${API_URL}/api/queryManagement/query/filterData`, 
  FILTERED_VISIT_STAGES: `${API_URL}/api/queryManagement/visit-stages/query/filter`,
};

export const HEALTH_CARE_APIS = {
  ALL_HEALTH_CARES: `${API_URL}/api/health_cares/search`,
  ADD_HEALTHCARE: `${API_URL}/api/health_cares`,
  GET_PORTALS: `${API_URL}/api/portal_meta_data`,
  GET_DEPARTMENTS: `${API_URL}/api/department`,
  GET_DESIGNATIONS: `${API_URL}/api/designation`,
  GET_QUALIFICATIONS: `${API_URL}/api/qualification`,
  GET_ALLUSERS_HEALTHCARES: `${API_URL}/api/health_care_management_user/health_cares/users`,
  RESET_PASSWORD: `${API_URL}/api/login-adapter/portal/resetPassword`,
};

export const COLOR_CODING_APIS = {
  GET_ALL_SCHEMES: `${API_URL}/api/getSchemesTypesByHospital`,
  GET_ALL_VISITS: `${API_URL}/api/getAllVisitTypes`,
  GET_ALL_STAGES: `${API_URL}/api/getStageBySchemeAndVisit`,
  GET_ALL_STATES: `${API_URL}/api/getStateByStage`,
  GET_ALL_TIMELINES: `${API_URL}/api/getAllTimelines`,
  GET_ALL_COLOR_CODINGS: `${API_URL}/api/getAllColorCodingsByHealthCare`,
  POST_COLOR_CODING: `${API_URL}/api/saveColorCodingWithSchemeType`,
  UPDATE_COLOR_CODING: `${API_URL}/api/updateColorCoding`,
  GET_ALL_UNITS: `${API_URL}/api/getAllUnits`,
};

// export const COLOR_CODING_APIS = {
//   GET_ALL_SCHEMES: `${API_URL}/api/getSchemesByHospital`,
//   GET_ALL_VISITS: `${API_URL}/api/getAllVisitTypes`,
//   GET_ALL_STAGES: `${API_URL}/api/getStageBySchemeAndVisit`,
//   GET_ALL_STATES: `${API_URL}/api/getStateByStage`,
//   GET_ALL_TIME_DURATIONS: `${API_URL}/api/getTimeDurations`,
//   GET_ALL_TIMELINES: `${API_URL}/api/getAllTimelines`,
//   GET_ALL_COLOR_CODINGS: `${API_URL}/api/getAllColorCodingsByHealthCare`,
//   // POST_COLOR_CODING: `${API_URL}/api/saveColorCodingWithSchemeType`,
//   POST_COLOR_CODING: `${API_URL}/api/saveColorCoding`,
//   UPDATE_COLOR_CODING: `${API_URL}/api/updateColorCoding`,
// };

export const ALL_SCHEMES_APIS = {
  ALL_SCHEMES: `${API_URL}/api/scheme_meta_data`,
  GET_SCHEME_ONBOARD: `${API_URL}/api/health_cares`,
  GET_SCHEME_ONBOARD_NEW: `${API_URL}/api/scheme_onboarding`,
  GET_SCHEME_MULTIPLE_HOSPITALS: `${API_URL}/api/health_cares/health_care_schemes/getActiveSchemesForMultipleHospitals`,
  ALL_HOSPITALS: `${API_URL}/api/health_cares/getAllHealthCareForUser`
};

export const CASES_APIS = {
  // TODO: Hard coding hospital id here, check if hospital id is available in access token
  ALL_CASES: `${API_URL}/api/health_cares`,
  CASES_VISIT: `${API_URL}/api/casesNew`,
  CASE_DETAILS: `${API_URL}/api/casesNew`,
  PATIENT_CASE_TYPES: `${API_URL}/api/case_type_meta_data/schemeId`,
  CASE_REFERRAL: `${API_URL}/api/referral_info/casesNew`,
};
export const DOCTOR_APIS = {
  // TODO: Hard coding hospital id here, check if hospital id is available in access token
  ALL_DOCTORS: `${API_URL}/api/health_cares`,
};
export const Bill_APIS = {
  // TODO: Hard coding hospital id here, check if hospital id is available in access token
  ALL_OPD_BILL: `${API_URL}/api/billing/opdSearch`,
  CONVERT_URL: `${API_URL}/api/document`,
  READ_DOCUMENT: `${API_URL}/api/health_cares`,
  READ_PDF_DOCUMENT: `${API_URL}/api/health_cares`,
  FETCH_SCHEME_CODE: `${API_URL}/api/billing/health_cares`,
  GENERATE_Bill: `${API_URL}/api/billing/new/health_cares`,
  GET_OPD_Bill: `${API_URL}/api/billing/new/opd_bill_header`,
  AUTO_DISCHARGE_SUMMARY: `${API_URL}/api/billing/autoAnswerQuestionsFromDischargeSummary`,
  TRIGGER_BILLING: `${API_URL}/api/triggerBilAudit`
};

export const USER_MANAGEMENT = {
  ALL_ROLES: `${API_URL}/api/roles`,
  ALL_HOSPITALS: `${API_URL}/api/health_cares`,
  USER_ASSIGNED_HOSPITALS: `${API_URL}/api/userManagement/health_care_management_user/user`,

  CREATE_USER: `${API_URL}/api/v1/auth/register`,
  UPDATE_USER: `${API_URL}/api/userManagement`,
  DELETE_USER: `${API_URL}/api/userManagement`,
  DELETE_ASSIGNED_HOSPITAL: `${API_URL}/api/userManagement/health_cares`,
  ALL_ACTIVE_USERS: `${API_URL}/api/userManagement/allActiveUser`,
  ASSIGN_HEALTHCARE: `${API_URL}/api/userManagement/health_care_management_user/assignMultipleHealthcare`,
  RESET_USER_PASSWORD: `${API_URL}/api/userManagement/change-password-by-email`,
};

export const ROLE_MANAGEMENT = {
  POST_ROLE_FUNCTIONALITIES: `${API_URL}/api/role`,
};

export const DOCUMENTS = {
  UPLOAD_DOCUMENTS: `${API_URL}/api/document`,
  READ_DOCS_OCR: `${API_URL}/api/ocr`,
  DOWNLOAD_DOCUMENT: `${API_URL}/api/documentsDownload`,
  DOWNLOAD_REPORT: `${API_CGHS}/cghs-api/reports/downloadReport`,
  DOWNLOAD_REPORT_NEW: `${API_CGHS}/cghs-new-api/reports/downloadReport`,
  EXPORT_REPORT_EXCEL: `${API_URL}/api/billAuditCombo/reportExport`,
  DELETE_DOCUMENT: `${API_URL}/api/document`,
  GET_DOCUMENTS: `${API_URL}/api/documents/modules/portalMetaDataId`,
  DEFICIENCY_CHECK: `${API_URL}/api/documentsDeficiencyChecklist/documentMasterId`,
  POST_DEFICIENCY_CHECK: `${API_URL}/api/queryManagement/documentsDeficiencyChecklist`,
  GET_DOCUMENT_DEFICIENCY_CHECK: `${API_URL}/api/queryManagement/documentsDeficiencyChecklist/documentId`,
  DISCHARGE_SUMMARY_READER: `${API_DISCHARGE_ML}/apiML/DSReader`,
};

export const DISCHARGE = {
  DOCTOR_TYPE_LIST: `${API_CGHS}/cghs-api/discharge/searchDoctor`,
  DOCTOR_TYPE_LIST_NEW: `${API_CGHS}/cghs-new-api/discharge/searchDoctor`,
  ROOM_TYPE_LIST: `${API_URL}/api/caseDischarge/portalGeneralRoomTypesData/portalMetaDataId`,
  SH_ROOM_TYPE_LIST: `${API_URL}/api/star-health/caseDischarge/portalGeneralRoomTypesData/portalMetaDataId`,
};

// export const DISCHARGE_SUMMARY = {
//   PROCEDURE_FIELD_LIST: `http://13.234.25.57:8089/procedure_Name`,
//   DISCHARGE_SUMMARY_PDF: `http://13.234.25.57:8089/dischargeSummary`,
// };

export const DISCHARGE_SUMMARY = {
  PROCEDURE_FIELD_LIST: `${API_DISCHARGE_ML_GENERATION}/apiML/dsGenerate/procedure_Name`,
  DISCHARGE_SUMMARY_PDF: `${API_DISCHARGE_ML_GENERATION}/apiML/dsGenerate/dischargeSummary`,
};

export const CGHS_DROPDOWNS = {
  DOCTOR_LIST: `${API_CGHS}/cghs-api/cghs/doctor`,
  DOCTOR_LIST_NEW: `${API_CGHS}/cghs-new-api/cghs/doctor`,
  GOVT_HOSPITAL_LIST: `${API_CGHS}/cghs-api/cghs/hospitals`,
  GOVT_HOSPITAL_LIST_NEW: `${API_CGHS}/cghs-new-api/cghs/hospitals`,
  DIAGNOSIS_LIST: `${API_CGHS}/cghs-api/cghs/diagnosis`,
  DIAGNOSIS_LIST_NEW: `${API_CGHS}/cghs-new-api/cghs/diagnosis`,
};

export const PROCEDURES = {
  // PROCEDURES_LIST: `http://13.201.143.66:8094/cghs/procedure`, //dev
  // SPECIALITY_LIST: `http://13.201.143.66:8094/cghs/speciality`, //dev

  // PROCEDURES_LIST : `https://uat-api.gsevenpro.com/cghs-api/cghs/procedure`, //uat
  // SPECIALITY_LIST : `https://uat-api.gsevenpro.com/cghs-api/cghs/speciality`  //uat

  PROCEDURES_LIST: `${API_CGHS}/cghs-api/cghs/procedure`, //uat
  SPECIALITY_LIST: `${API_CGHS}/cghs-api/cghs/speciality`, //uat

  PROCEDURES_LIST_NEW: `${API_CGHS}/cghs-new-api/cghs/procedure`, //uat
  SPECIALITY_LIST_NEW: `${API_CGHS}/cghs-new-api/cghs/speciality`, //uat
};

export const GET_ALL_DOCUMENTS_DATA = (
  caseId: number,
  visitId: number,
  portalMetaDataId: number
) =>
  `${API_URL}/api/caseId/${caseId}/visit/${visitId}/portalMetaDataId/${portalMetaDataId}/getAllAttachments`;
export const GET_ALL_STARHEALTH_DOCUMENTS_DATA = (
  caseId: number,
  visitId: number,
  schemeId: number
) =>
  `${API_URL}/api/caseId/${caseId}/visit/${visitId}/schemeId/${schemeId}/getAllAttachments`;
export const UPDATE_ALL_DOCUMENTS_DATA = (caseId: number, visitId: number) =>
  `${API_URL}/api/caseId/${caseId}/visitId/${visitId}/attachments`;
export const DOWNLOAD_ATTACHMENTS = (stageId: number, visitId: number) =>
  `${API_URL}/api/document/visitId/${visitId}/stageId/${stageId}/zip-download`;
export const SENT_TO_QC_BILL_AUDIT = (caseId: number, visitId: number) =>
  `${API_URL}/api/attachments/billAudit/caseId/${caseId}/visitId/${visitId}`;
export const REQUIRED_DOCUMENTS_BY_MASTER = `${API_URL}/api/attachments/bills/required-documents-by-master`;

export const BILLING_APIS = {
  GetDischargeSummaryStatus: `${API_URL}/api/cghsBilling/fetchCurrentDsAuditStatus`,
  //tpa billing
  TpaBillGeneratePostApi: `${API_URL}/api/tpaBilling/post`,
  TpaBillGetApi: `${API_URL}/api/tpaBilling/get`,
  TpaBillUpdatePutApi: `${API_URL}/api/tpaBilling/update`,
  GetTPABillList: `${API_URL}/api/tpaBilling/get/all`,
  ChangeBillStatus: `${API_URL}/api/tpaBilling/changeStatus`,
  UpdateByFilterPutApi: `${API_URL}/api/tpaBilling/update/by/filter`,
  // UpdateHospitalRoomTypePutApi: `${API_URL}/api/tpaBilling`,
  DownloadTPABillItems: `${API_URL}/api/tpaBilling/download/tpaBillItem`,
  GetTPAMappedCollections: `${API_URL}/api/tpaBilling/get/all/collectionWithSubCollections`,
  // GetTPASubCollections: `${API_URL}/api/tpaBilling/get/all/subCollections`,
  GetTPADSBillCompData: `${API_URL}/api/tpaBilling/get/dsAndBillCompData`,
  GetTPARoomType: `${API_URL}/api/tpaBilling/getRoomsBy`,
  GetHospitalRoomType: `${API_URL}/api/tpaBilling/getHospitalRoomsBy`,
  GetAllSchemes: `${API_URL}/api/tpaBilling/getAllSchemes`,
  DeleteTPAPatientBills: `${API_URL}/api/tpaBilling/delete/tpaBills`,
  GetHospitalProcedures: `${API_URL}/api/tpaBilling/getHospitalProcedures`,
  PostCorrectedHospitalProcedures: `${API_URL}/api/tpaBilling/post/correctedHospitalProcedures`,
  GetInsuranceProcedures: `${API_URL}/api/tpaBilling/getInsuranceProcedures`,
  PostCorrectedInsuranceProcedures: `${API_URL}/api/tpaBilling/post/correctedInsuranceProcedures`,
  AllTPABillItems: `${API_URL}/api/tpaBilling/getAllTpaBillItems`,
  UpdateTPABillItem: `${API_URL}/api/tpaBilling/updateTpaBillItem`,
  TpaDischargeSummaryUpdatedItems: `${API_URL}/api/tpaBilling/addNewItemInDischargeSummary`,
  GovtDischargeSummaryUpdatedItems: `${API_URL}/api/cghsBilling/addNewItemInDischargeSummary`,
  GovtBillAuditGetApi: `${API_URL}/api/v2/cghsBilling/get/bill`,
  TRIGGER_BILLING: `${API_URL}/api/triggerBilAudit`,

  //govt Billing
  GovtBillGeneratePostApi: `${API_URL}/api/cghsBilling/save/bill/health_cares`,
  GovtBillGetApi: `${API_URL}/api/cghsBilling/get/bill`,
  GovtBillUpdatePutApi: `${API_URL}/api/cghsBilling/update`,
  GovtBillAuditUpdatePutApi: `${API_URL}/api/v2/cghsBilling/save/bill`,
  GetGovtBillList: `${API_URL}/api/cghsBilling/get/all/health_cares`,
  ChangeWardTypePutApi: `${API_URL}/api/cghsBilling/updateByWard`,
  GetGovtDSBillCompData: `${API_URL}/api/cghsBilling/get/dsAndBillCompData`,
  DeleteGovtPatientBills: `${API_URL}/api/cghsBilling/delete/cghsBills`,
  GetGovtMappedCollections: `${API_URL}/api/cghsBilling/get/all/collectionWithSubCollections`,
  GetAllSchemeCodes: `${API_URL}/api/cghsBilling/getAllSchemeCodes`,
  GetAllV2SchemeCodes: `${API_URL}/api/v2/cghsBilling/getAllSchemeCodes`,
  AllGovtBillItems: `${API_URL}/api/cghsBilling/getAllCghsBillItems`,
  UpdateGovtBillItem: `${API_URL}/api/cghsBilling/updateCghsBillItem`,
  AUDIT_BLL_CHECK: `${API_URL}/api/cghsBilling/checkDuplicateBills`,
  GovtApproveBill: `${API_URL}/api/v2/cghsBilling/bill`,
  DSBillComparison: `${API_URL}/api/v2/cghsBilling/dsAndBillCompData`,
  ChangeWardTypePutApiNew: `${API_URL}/api/v2/cghsBilling/recalculate`,
  DownloadBillSummary: `${API_URL}/api/v2/cghsBilling/bill`,
  GOVT_BILLING: `${API_URL}/api/v2`,
};

export const OHDR_APIS = {
  OHDR_DIALYSIS_PERFORMED_BY: `${API_URL}/hd-processing/ohdr/dialysis-performed-by`,
  OHDR_NS: `${API_URL}/hd-processing/ohdr/ns`,
  OHDR_AVF: `${API_URL}/hd-processing/ohdr/avf`,
  OHDR_HEPARIN: `${API_URL}/hd-processing/ohdr/heparin`,
  OHDR_FULL_BLOOD_VOLUME: `${API_URL}/hd-processing/ohdr/full-blood-volume`,
  OHDR_BLOOD_TUBING_COUNT: `${API_URL}/hd-processing/ohdr/blood-tubing-count`,
  OHDR_DIALYZER_COUNT: `${API_URL}/hd-processing/ohdr/dialyzer-count`,
  OHDR_VASCULAR_ACCESS_TYPES: `${API_URL}/hd-processing/ohdr/vascular-access-types`,
  Get_Portal_Patient_Details: `${API_URL}/hd-processing/ayb-portal/fetch-portal-patient-details`,
  OHDR_CREATE_PATIENT: `${API_URL}/hd-processing/patient/createPatient`,
  Get_Database_Patient_Details: `${API_URL}/hd-processing/patient/search`,
  Get_DB_Patient_Details: `${API_URL}/hd-processing/search/withSearchCriteria`,
  OHDR_APPOINTMENTS: `${API_URL}/appointments/schedule/visit`,
  OHDR_VISIT_DETAILS: `${API_URL}/hd-processing/ohdr-visit`,
  OHDR_PATIENT_LIST: `${API_URL}/hd-processing/patient/appointment-patient-list`,
  HDR_PATIENT_LIST: `${API_URL}/hd-processing/patient`,
  OHDR_PARTICULAR_VISIT_DETAILS: `${API_URL}/hd-processing/patient/getOHDRDetails/visitId`,
  OHDR_CHECKIN_CHECKOUT: `${API_URL}/hd-processing/ayb-portal/update-checkin-checkout`,
  HDR_VISIT_DETAILS: `${API_URL}/hd-processing/hdr`,
  UPDATE_HDR_VISIT_DETAILS: `${API_URL}/hd-processing/hdr/visit-id`,
  APPOINTMENTS_SLOTS: `${API_URL}/appointments/available-slots`,
  UPDATE_APPOINTMENT_SLOT: `${API_URL}/appointments/visit`,
  GET_ALL_ATTACHMENTS: `${API_URL}/hd-processing/attachments`,
  DOCUMENT_UPLOAD: `${API_URL}/hd-processing/document/upload`,
  DOCUMENT_DELETE: `${API_URL}/hd-processing/document/delete`,
  DOCUMENT_REJECT: `${API_URL}/hd-processing/document/reject`,
  GET_DISCHARGE_DATA: `${API_URL}/hd-processing/discharge/getDischarge`,
  CREATE_DISCHARGE: `${API_URL}/hd-processing/discharge/createDischarge`,
  UPDATE_DISCHARGE: `${API_URL}/hd-processing/discharge/updateDischarge`,
  GET_CLAIM_DATA: `${API_URL}/hd-processing/claim/getClaim`,
  CREATE_CLAIM: `${API_URL}/hd-processing/claim/createClaim`,
  UPDATE_CLAIM: `${API_URL}/hd-processing/claim/updateClaim`,
  GET_STAGE_DOCUMENTS: `${API_URL}/hd-processing/attachments/getStageWiseAttachments`,
  SEARCH_PATIENTS: `${API_URL}/hd-processing/patient-list/search-patient`,
  SCHEDULE_GET_APPOINTMENTS: `${API_URL}/appointments/schedule`,
  TC_GENERATION: `${API_URL}/hd-processing/otc/generate-treatment-chart`,
  DAY_CLOSURE_SUMMARY: `${API_URL}/hd-processing/day-closure/summary`,
  SHIFT_CLOSURE_SUMMARY: `${API_URL}/hd-processing/shift-closure/summary`,
  PENDING_PATIENT_DETAILS: `${API_URL}/hd-processing/day-closure/pending-status-patients`,
  SHIFT_PENDING_PATIENT_DETAILS: `${API_URL}/hd-processing/shift-closure/pending-status-patients`,
  DAY_CLOSURE: `${API_URL}/hd-processing/day-closure`,
  SHIFT_CLOSURE: `${API_URL}/hd-processing/shift-closure`,
  GEO_IMAGE_UPLOAD: `${API_URL}/hd-processing/attachments/upload/image-with-geo`,
  GET_PREAUTH: `${API_URL}/hd-processing/pre-auth/getPreAuth`,
  UPDATE_PREAUTH: `${API_URL}/hd-processing/pre-auth/updatePreAuth`,
  POST_PREAUTH: `${API_URL}/hd-processing/pre-auth/createPreAuth`,
  DROPDOWN_COUNTS: `${API_URL}/hd-processing/ohdr/dropdown-counts`,
  GET_TIMELINE: `${API_URL}/hd-processing/timeline/get-timelines`,
  GET_DAY_REPORT: `${API_URL}/hd-processing/day-report`,
  GET_MONTHLY_REPORT: `${API_URL}/hd-processing/monthly-report`,
  VISIT_SCHEME_STAGES: `${API_URL}/hd-processing/visit-scheme-stage/visitSchemeStages`,
  GET_QUERIES_OHDR: `${API_URL}/hd-processing/queries/get-queries`,
  CREATE_QUERY_OHDR: `${API_URL}/hd-processing/queries/create`,
  REPLY_QUERY_OHDR: `${API_URL}/hd-processing/queries/reply-query`,
  DOCUMENT_DEFICIENCY_QUES: `${API_URL}/hd-processing/document-deficiency/get-deficiencies-response`,
  MARK_DROP_CALL: `${API_URL}/hd-processing/appointment-visit/mark-drop-call`,
  MARK_DROP_CLAIM: `${API_URL}/hd-processing/appointment-visit/mark-drop-claim`,
  ASSIGN_TO_ME: `${API_URL}/hd-processing/appointment-assignment/assign-to-me`,
  POST_DOCUMENT_DEFICIENCY: `${API_URL}/hd-processing/document-deficiency`,
  GET_QUERY_LIST: `${API_URL}/hd-processing/query/query-list`,
  CONSOLIDATED_BILL_PDF: `${API_URL}/hd-processing/consolidated-bill/generate-pdf`,
  DELETE_APPOINTMENT_VISIT: `${API_URL}/appointments/delete-appointment-visit`,
  ADD_APPOINTMENT_VISIT: `${API_URL}/appointments/add-appointment-visit`,
  SESSIONS_DOCUMENTS: `${API_URL}/hd-processing/attachments/getSessionAttachments`,
  CALENDAR_DETAILS: `${API_URL}/appointments/calendar/view`,
  SEND_TO_QC: `${API_URL}/hd-processing/qc/send-to-qc`,
  APPROVE_OR_REJECT_VISIT: `${API_URL}/hd-processing/qc/visit-approval`,
};

export const OTC_APIS = {
  OTC_PATIENT_LIST: `${API_URL}/hd-processing/otc/tc-patient-list`,
  UPDATE_OTC_DETAIL: `${API_URL}/hd-processing/otc`,
  OTC_READING: `${API_URL}/hd-processing/otc-reading/createOTCReading`,
  UPDATE_OTC_READING: `${API_URL}/hd-processing/otc-reading/updateOTCReading`,
  GET_OTC: `${API_URL}/hd-processing/otc/visit`,
  GET_OTC_READINGS_LIST: `${API_URL}/hd-processing/otc-reading/getOTCReadingByOtcId`,
  GET_OTC_READING_BY_ID: `${API_URL}/hd-processing/otc-reading/getOTCReadingById`,
  DELETE_OTC_READING_BY_ID: `${API_URL}/hd-processing/otc-reading/deleteOTCReadingById`,
  UPLOAD_DIALYSIS_IMAGE: `${API_URL}/hd-processing/dialysis-reader/read-dialysis-machine`,
};

export const NHA_PORTAL = {
  NHA_PORTAL_DETAILS: `${API_URL}/hd-processing/ayb-portal/login-details`,
  NHA_PORTAL_LOGIN: `${API_URL}/hd-processing/ayb-portal/perform-login`,
  NHA_PORTAL_LOGOUT: `${API_URL}/hd-processing/ayb-portal/perform-logout`,
  NHA_PORTAL_SCREEN: `${API_URL}/hd-processing/ayb-portal/screen`,
};

export const MANAGEMENT_DASHBOARD = {
  business: `${API_URL}/dashboard/management/business`,
  split: `${API_URL}/dashboard/management/split`,
  businessTrend: `${API_URL}/dashboard/management/businessTrend`,
  schemeWiseSettlement: `${API_URL}/dashboard/management/schemeWiseSettlement`,
  settlementTrend: `${API_URL}/dashboard/management/settlementTrend`,
  dso: `${API_URL}/dashboard/management/dso`,
  businessTillDate: `${API_URL}/dashboard/management/businessTillDate`,
  settledTillDate: `${API_URL}/dashboard/management/settledTillDate`,
  settledSplit: `${API_URL}/dashboard/management/settledSplit`,
};

export const IPD_BILLING_APIS = {
  UPLOAD_DOC: `${API_URL}/api/document`,
  IPD_QUESTIONNAIRES: `${API_URL}/api/billing/questionnaires`,
  POST_QUESTION_ANSWER_COLLECTION: `${API_URL}/api/billing/new/question_answers_collection`,

  RESET_IPD_SCHEME_BILL: (schemeBillHeaderId: number | null) =>
    `${API_URL}/api/billing/new/scheme_bill_header/${schemeBillHeaderId}/reset`,

  GET_IPD_BILL_LIST: (hospitalId: number) =>
    `${API_URL}/api/billing/ipdSearch/healthcares/${hospitalId}`,
  GET_BILL_MAPPING: (hospitalId: number) =>
    `${API_URL}/api/billing/new/health_cares/${hospitalId}/Bills`,
  GET_EDIT_IPD_BILL_MAPPING: (hospitalId: number, ipdBillId: string) =>
    `${API_URL}/api/billing/new/health_cares/${hospitalId}/Bills/${ipdBillId}`,
  GET_HEALTHCARE_BILL_HEADER: (healthCareBillHeaderId: number) =>
    `${API_URL}/api/billing/new/healthcare_bill_header/${healthCareBillHeaderId}`,
  GET_PATIENT_PAYABLE: (healthCareBillHeaderId: number) =>
    `${API_URL}/api/billing/new/healthcare_bill_header/${healthCareBillHeaderId}/healthcare_bill_items/patient_payable`,
  GET_QUESTION_ANSWER_COLLECTION: (billMappingId: number) =>
    `${API_URL}/api/billing/new/question_answers_collection/bill_mapping_id/${billMappingId}`,
  GET_SCHEME_BILL_HEADER: (schemeBillHeaderId: number) =>
    `${API_URL}/api/billing/new/scheme_bill_header/${schemeBillHeaderId}`,
  UPDATE_SCHEME_BILL_ITEMS: (
    hospitalId: number | undefined,
    billMappingId: number | null,
    schemeBillHeaderId: number | null
  ) =>
    `${API_URL}/api/billing/new/health_cares/${hospitalId}/Bills/${billMappingId}/scheme_bill_header/${schemeBillHeaderId}`,
  APPROVE_IPD_BILL: (
    hospitalId: number | undefined,
    currBillMappingId: number | undefined,
    currHealthCareBillHeaderId: number | undefined,
    currSchemeBillHeaderId: number | undefined
  ) =>
    `${API_URL}/api/billing/changeStatus/healthCare/${hospitalId}/Bills/${currBillMappingId}/healthCareBillHeader/${currHealthCareBillHeaderId}/schemeBillHeader/${currSchemeBillHeaderId}`,
  DOWNLOAD_ABSTRACT_EXCEL: (currSchemeBillHeaderId: number | undefined) =>
    `${API_URL}/api/billing/new/ipd-bill-xls?schemeBillHeaderId=${currSchemeBillHeaderId}`,
  DOWNLOAD_ABSTRACT_ZIP: (
    hospitalId: number | undefined,
    dateFrom: string | undefined,
    dateTo: string | undefined
  ) =>
    `${API_URL}/api/billing/new/ipd-bill-zip?healthCareId=${hospitalId}&dateFrom=${dateFrom}&dateTo=${dateTo}`,
};

export const OPD_BILLING_APIS = {
  UPLOAD_DOC: `${API_URL}/api/document`,
  OPD_QUESTIONNAIRES: `${API_URL}/api/billing/questionnaires`,
  POST_QUESTION_ANSWER_COLLECTION: `${API_URL}/api/billing/new/question_answers_collection`,
  RESET_OPD_SCHEME_ITEM: (schemeBillHeaderId: number | null) =>
    `${API_URL}/api/billing/new/scheme_opd_bill_header/${schemeBillHeaderId}/reset`,

  GET_OPD_BILL_LIST: (hospitalId: number) =>
    `${API_URL}/api/billing/opdSearch/healthcares/${hospitalId}`,
  GET_BILL_MAPPING: (hospitalId: number) =>
    `${API_URL}/api/billing/new/health_cares/${hospitalId}/OpdBills`,
  GET_EDIT_OPD_BILL_MAPPING: (hospitalId: number, ipdBillId: string) =>
    `${API_URL}/api/billing/new/health_cares/${hospitalId}/OpdBills/${ipdBillId}`,
  GET_HEALTHCARE_BILL_HEADER: (healthCareBillHeaderId: number) =>
    `${API_URL}/api/billing/new/healthcare_opd_bill_header/${healthCareBillHeaderId}`,
  GET_PATIENT_PAYABLE: (healthCareBillHeaderId: number) =>
    `${API_URL}/api/billing/new/healthcare_opd_bill_header/${healthCareBillHeaderId}/healthcare_bill_items/patient_payable`,
  GET_QUESTION_ANSWER_COLLECTION: (billMappingId: number) =>
    `${API_URL}/api/billing/new/question_answers_collection/bill_mapping_id/${billMappingId}`,
  GET_SCHEME_BILL_HEADER: (schemeBillHeaderId: number) =>
    `${API_URL}/api/billing/new/scheme_opd_bill_header/${schemeBillHeaderId}`,
  UPDATE_SCHEME_BILL_ITEMS: (
    hospitalId: number | undefined,
    billMappingId: number | null,
    schemeBillHeaderId: number | null
  ) =>
    `${API_URL}/api/billing/new/health_cares/${hospitalId}/OpdBills/${billMappingId}/scheme_opd_bill_header/${schemeBillHeaderId}`,
  APPROVE_OPD_BILL: (
    hospitalId: number | undefined,
    currBillMappingId: number | undefined,
    currHealthCareBillHeaderId: number | undefined,
    currSchemeBillHeaderId: number | undefined
  ) =>
    `${API_URL}/api/billing/changeStatus/healthCare/${hospitalId}/OpdBills/${currBillMappingId}/healthCareBillHeader/${currHealthCareBillHeaderId}/schemeBillHeader/${currSchemeBillHeaderId}`,
  DOWNLOAD_ABSTRACT_EXCEL: (currSchemeBillHeaderId: number | undefined) =>
    `${API_URL}/api/billing/new/ipd-bill-xls?schemeBillHeaderId=${currSchemeBillHeaderId}`,
  DOWNLOAD_ABSTRACT_ZIP: (
    hospitalId: number | undefined,
    dateFrom: string | undefined,
    dateTo: string | undefined
  ) =>
    `${API_URL}/api/billing/new/ipd-bill-zip?healthCareId=${hospitalId}&dateFrom=${dateFrom}&dateTo=${dateTo}`,
};

export const IPD_BILL_STATUS_COMPLETED = ["Bill Generated", "Approved"];

export const OPD_BILL_STATUS_COMPLETED = ["Bill Generated", "Approved"];

export const LIST_ORDER = {
  DESC: "DESC",
  ASC: "ASC",
};

export const LIST_DEFAULT_PAGE_SIZE = 100;

export const APP_EVENTS = {
  SHOW_LAST_VISIT_MODAL: "showLastVisitModal",
  SHOW_IPD_TRACE_MODAL: "showIPDTraceModal",
  SHOW_OPD_TRACE_MODAL: "showOPDTraceModal",
  SHOW_PDF_VIEWER_MODAL: "showPdfViewerModal",
  SHOW_DOC_VIEWER_MODAL: "showPdfViewerModal",
  SHOW_PACKAGED_ITEMS_MODAL: "showPackagedItemsModal",
  SHOW_PACKAGED_ITEMS_MODAL_OPD: "showPackagedItemsModalOpd",
  SHOW_VIEW_PACKAGED_ITEMS_MODAL: "showViewPackagedItemsModal",
  SHOW_VIEW_PACKAGED_ITEMS_MODAL_OPD: "showViewPackagedItemsModalOPD",

  SHOW_GET_CLAIM_ID_MODAL: "showGetClaimIdModal",
  SHOW_CONFIRM_DOC_UPLOAD_MODAL: "showConfirmDocUploadModal",
  SHOW_ALERT: "showAlert",
  SHOW_ECHS_REVIEW_REQUEST_MODAL: "showEchsReviewRequestModal",
  SHOW_ENHANCEMENT_PENDING_MODAL: "showEnhancementPendingModal",
  SHOW_ENHANCEMENT_PENDING_MODAL_CGHS_NEW: "showEnhancementPendingModalCghsNew",
};
export const CLAIM_LIST = {
  // CLAIM_lIST_DOWNLOAD: `${API_NEW_URL}/ihx/claim/claim-status`,   //uat
  CLAIM_lIST_DOWNLOAD: `${API_NEW_URL}/ihx/claim/claim-status`, //dev
};

export const PREAUTH_MICROSERVICE = {
  API_MICROSERVICE: `${API_MICROSERVICE}`,
};

// IPD Bills Related
export const ADD_IPD_BILL_WIZARD_ITEMS = [
  {
    step: 0,
    title: "Patient Details",
    canNavigate: true,
    completed: false,
  },
  {
    step: 1,
    title: "Upload IPD Docs",
    canNavigate: true,
    completed: false,
  },
  {
    step: 2,
    title: "Questionnaire",
    canNavigate: true,
    completed: false,
  },
  {
    step: 3,
    title: "View/Edit IPD Bill",
    canNavigate: true,
    completed: false,
  },
];

// OPD Bills Related
export const ADD_OPD_BILL_WIZARD_ITEMS = [
  {
    step: 0,
    title: "Patient Details",
    canNavigate: true,
    completed: false,
  },
  {
    step: 1,
    title: "Upload OPD Docs",
    canNavigate: true,
    completed: false,
  },
  {
    step: 2,
    title: "View/Edit OPD Bill",
    canNavigate: true,
    completed: false,
  },
];

export const IPD_REQ_DOCS_CATEGORY = [
  "IPD Module Bill Required",
  "IPDModuleBillRequired",
];

export const OPD_REQ_DOCS_CATEGORY = [
  "OPD Module Bill Required",
  "OPDModuleBillRequired",
];

export const ADD_IPD_MANUAL_QUESTION_TYPES = {
  INPUT: "inputbox",
  BUTTON: "button",
  DATE: "inputboxDate",
};

export const ADD_OPD_MANUAL_QUESTION_TYPES = {
  INPUT: "inputbox",
  BUTTON: "button",
  DATE: "inputboxDate",
};

export const ADD_IPD_MANUAL_QUESTION_SUBMIT_ANS = "Proceede";

export const ADD_OPD_MANUAL_QUESTION_SUBMIT_ANS = "Proceede";

export const IPD_RELATED_DOCS = [
  { value: "DISCHARGE SUMMARY", label: "DISCHARGE SUMMARY" },
  { value: "REFERRAL LETTER", label: "REFERRAL LETTER" },
  { value: "OTHERS", label: "OTHERS" },
];

export const OPD_RELATED_DOCS = [
  { value: "DISCHARGE SUMMARY", label: "DISCHARGE SUMMARY" },
  { value: "REFERRAL LETTER", label: "REFERRAL LETTER" },
  { value: "OTHERS", label: "OTHERS" },
];

export const AYUSHMAN_B = {
  BASE_URL: `${API_URL}/api/ayushmanBharat`,
  // BASE_URL: 'http://localhost:8090/api/ayushmanBharat',
  ADAPTER_BASE_URL: `${API_URL}/api/kasp`,
};
